import { FC } from 'react';
import { AdminClientLayout } from 'pages/atoms';
import { ClientCompaniesList } from 'containers/admin';

const AdminClientCompaniesPage: FC = () => {
  return (
    <AdminClientLayout>
      <ClientCompaniesList />
    </AdminClientLayout>
  );
};

export default AdminClientCompaniesPage;
